import usePrivateAxios from "@/common/api/usePrivateAxios";
import { ErrorResponse } from "@/common/types/errorResponse";
import { UpdatePermissionValidationSchema } from "@/features/permissions/schemas/create.schema";
import { useMutation } from "@tanstack/react-query";

interface UseUpdateEstablishmentPermissionProps {
  id: string
  onSuccess: () => void
  onError: (error: ErrorResponse) => void
}

const useUpdateEstablishmentPermission = ({ id, onSuccess, onError }: UseUpdateEstablishmentPermissionProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['updateEstablishmentPermission'],
    mutationFn: (form: UpdatePermissionValidationSchema) => privateAxios.put(`/establishment/permissions/${id}`, form),
    onSuccess,
    onError
  });
}

export default useUpdateEstablishmentPermission
